<template>
  <div class="editor">
    <div class="column is-half is-offset-one-quarter has-text-left">
      <b-field label="Тип новости" class="article-type">
        <el-radio-group v-model="type">
          <el-radio-button label="ordinary">Обычная</el-radio-button>
          <el-radio-button label="important">Важная</el-radio-button>
          <el-radio-button label="obligatory">Обязательная <br>  к прочтению</el-radio-button>
        </el-radio-group>
      </b-field>
      <b-field label="Дата публикации">
        <datepicker
          v-model="article.publishDate"
          input-class="input"
          language="ru"
          ></datepicker>
      </b-field>
      <b-field label="Название">
        <b-input v-model='article.title' required></b-input>
      </b-field>
      <b-field label="Текст">
        <Editor v-model="article.text" :editorToolbar="customToolbar"/>
      </b-field>
      <div class="clients-search">
        <h5 class="has-text-centered">Выберите клиентов, которым отправить уведомление</h5>
      </div>
      <div class="search-wrapper">
        <b-input placeholder="Поиск..." @change="filterClientsList" class="search-input"></b-input>
        <b-checkbox @change="selectAll">Выбрать всех</b-checkbox>
      </div>
      <div class="selection-container">
        <div class="client-item" v-for="client in filteredClientsList">
          <div class="client-data">
            <p>{{client.ClientName}}</p>
            <p class="dbo">{{client.DBO}}</p>
          </div>
          <b-checkbox @change="clientSelected(client)" v-model="client.isSelected"></b-checkbox>
        </div>
        <p v-if="filteredClientsList.length === 0 && this.clients" class="has-text-centered is-empty">По вашему запросу ничего не найдено</p>
      </div>
      <button class="button is-fullwidth" @click="save">СОХРАНИТЬ</button>
      <router-link :to="{ name: 'Notifications' }" class="button is-fullwidth">ОТМЕНИТЬ</router-link>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { VueEditor as Editor } from 'vue2-editor'

import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import deepcopy from 'deepcopy'
import FuzzySearch from 'fuzzy-search'

moment.locale('ru')

export default {
  name: 'NotificationEditor',
  data () {
    return {
      clientsList: [],
      filteredClientsList: [],
      selectedClients: [],
      type: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['link']
      ]
    }
  },
  components: {
    Datepicker,
    Editor
  },
  computed: {
    ...mapState(['news', 'clients']),
    article () {
      const data = {
        ...(this.news.find(article => article.id === this.$route.params.id) || {
          type: 'ordinary',
          title: '',
          text: '',
          publishDate: new Date(),
          clientsId: []
        })
      }
      this.type = data.type
      return data
    }
  },
  created () {
    this.getClients()
    this.clientsList = this.clientsData
  },
  methods: {
    ...mapActions(['saveArticle', 'getClients']),
    save () {
      const clientsId = this.selectedClients.map(c => c.clientId)
      if (this.$route.params.id !== 'new') {
        this.article.credentials = clientsId.map(id => {
          const credendtial = this.article.credentials.find(c => c.clientsId === id)
          if (credendtial) {
            return credendtial
          } else {
            return { clientId: id, status: false, time: null, clientCode: this.clients.find(c => c.clientId === id).clientCode }
          }
        })
      } else {
        this.article.credentials = clientsId.map(id => ({ clientId: id, status: false, time: null, clientCode: this.clients.find(c => c.clientId === id).clientCode }))
      }
      this.article.type = this.type
      this.saveArticle(this.article)
      .then(() => this.$router.push({ name: 'Notifications' }))
    },
    filterClientsList (pattern) {
      const searcher = new FuzzySearch(this.clientsList, ['ClientName', 'DBO'], {
        caseSensitive: false,
        sort: true
      })
      const result = searcher.search(pattern)
      this.filteredClientsList = result
    },
    selectAll (value) {
      this.selectedClients = []
      this.filteredClientsList.forEach(c => {
        c.isSelected = value
        if (value) {
          this.selectedClients.push(c)
        }
      })
    },
    clientSelected (client) {
      const exist = this.selectedClients.find(c => c.clientId === client.clientId)
      if (!exist) {
        this.selectedClients.push(client)
      } else {
        this.selectedClients = this.selectedClients.filter(c => c.clientId !== client.clientId)
      }
    }
  },
  watch: {
    clients (val) {
      const copy = deepcopy(val)
      const modifiedCopy = copy.map(s => {
        s.isSelected = false
        return s
      })
      this.clientsList = modifiedCopy
      this.article.credentials && this.article.credentials.forEach(c => {
        const client = this.clientsList.find(s => s.clientId === c.clientId)
        if (client) {
          client.isSelected = true
          this.selectedClients.push(client)
        }
      })
      this.filteredClientsList = modifiedCopy
    }
  }
}
</script>

<style scoped>
.article-type .control {
  width: 33.33%;
  justify-content: center;
}
.search-input {
  max-width: 300px;
}
.search-wrapper {
  position: relative;
}
.clients-search h5 {
  color: darkgray;
  margin: 15px 0 20px;
}
.selection-container {
  border: 1px solid #ccc;
  max-height: 600px;
  overflow-y: scroll;
  margin: 15px 0 40px;
  min-height: 400px;
}
.client-item {
  border-bottom: 1px solid #ccc;
  padding: 8px;
  position: relative;
}
.checkbox {
  display: block;
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}
.client-item:after {
  content: "";
  display: table;
  clear: both;
}
.dbo {
  color: darkgray;
}
.client-data {
  width: calc(100% - 30px);
}
.is-empty {
  margin: 15px 0 0;
}
.el-radio-group {
  width: 100%;
}
.el-radio-button {
  width: 33%;
}
.is-active {
  border-bottom: none;
}
</style>
<style>
.article-type .el-radio-button__inner{
  width: 100%;
  justify-content: center;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// Editor.vue?6ef7d56a